import { confirmsDiagnosticsReset, DIAGNOSTICS_RESET_PHRASE } from '@prerender/diagnostics-api';
import { useId } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';

import { resetErrorMessage } from './incidentsErrorMessage';
import type { RequestError } from './loadable';

const RESET = 'Reset';
const RESET_DIAGNOSTICS = 'Reset diagnostics';

type ResetDiagnosticsViewProps = {
  detectionRunning: boolean;
  open: boolean;
  phrase: string;
  resetting: boolean;
  refusal: RequestError | undefined;
  onOpen: () => void;
  onPhraseChange: (phrase: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
};

function ResetDiagnosticsView({
  detectionRunning,
  open,
  phrase,
  resetting,
  refusal,
  onOpen,
  onPhraseChange,
  onCancel,
  onConfirm,
}: ResetDiagnosticsViewProps): JSX.Element {
  const titleId = useId();
  const phraseId = useId();

  return (
    <>
      <Button variant="danger" size="sm" aria-label={RESET_DIAGNOSTICS} disabled={detectionRunning} onClick={onOpen}>
        {RESET}
      </Button>
      <Modal show={open} onHide={onCancel} aria-labelledby={titleId}>
        <Modal.Header closeButton={true}>
          <Modal.Title id={titleId}>{RESET_DIAGNOSTICS}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {refusal !== undefined && <Alert variant="danger">{resetErrorMessage(refusal)}</Alert>}
          <Form.Label htmlFor={phraseId}>
            Type <code>{DIAGNOSTICS_RESET_PHRASE}</code> to confirm
          </Form.Label>
          <Form.Control
            id={phraseId}
            autoComplete="off"
            value={phrase}
            onChange={(event) => onPhraseChange(event.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="danger" disabled={resetting || !confirmsDiagnosticsReset(phrase)} onClick={onConfirm}>
            {RESET_DIAGNOSTICS}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ResetDiagnosticsView;
